import CheckIcon from "../../icon/CheckIcon.js";
import { cn } from "@rosette/ts/src/util/cn.js";


interface CheckboxInputProps {
    id: string;
    name?: string;
    checked: boolean;
    setChecked: (value: boolean) => void;
    disabled?: boolean;
}

export function CheckboxInput({
    id, name, checked, setChecked, disabled,
}: CheckboxInputProps) {
    return (
        <div className="relative flex">
            <input
                className={cn(
                    "size-[1.2em] cursor-pointer rounded-sm border border-control bg-page text-base shadow-md",
                    "transition-all duration-200 checked:border-0 checked:bg-focus",
                    "focus:outline-2 focus:outline-offset-2 focus:outline-primary",
                    "disabled:cursor-not-allowed disabled:opacity-50",
                )}
                type="checkbox"
                id={id}
                name={name}
                checked={checked}
                onChange={e => setChecked(e.target.checked)}
                disabled={disabled} />

            {checked && (
                <CheckIcon className="pointer-events-none absolute top-1/2 left-1/2 block size-4/5 [transform:translate(-50%,-50%)] fill-current text-white" />
            )}
        </div>
    );
}
